__turbopack_context__.v({
  "content": "iconList-module-scss-module__dUQ3-G__content",
  "description": "iconList-module-scss-module__dUQ3-G__description",
  "iconList": "iconList-module-scss-module__dUQ3-G__iconList",
  "iconListItem": "iconList-module-scss-module__dUQ3-G__iconListItem",
  "iconListItemIcon": "iconList-module-scss-module__dUQ3-G__iconListItemIcon",
  "title": "iconList-module-scss-module__dUQ3-G__title",
});
